import React from 'react';
import { 
  Box, 
  Text, 
  VStack,  
  Image, 
  useColorModeValue,
  Divider,
  Icon,
  Flex,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaMapMarkerAlt, FaClock, FaUsers } from 'react-icons/fa';

// Import event images
import conferencePoster from "../media/conferencePoster.JPG";
import empoweringgenerations2023_poster from "../media/events/empoweringgenerations2023_poster.jpg";
import allnightstireup_poster from "../media/events/Allnightstireup_poster.jpg";
import ahightofempowerment2018 from "../media/events/ahightofempowerment2018.jpg";
import beEmpowered2018_poster from "../media/events/BeEmpowered2018_poster.jpg";
import arisenightvigil2017_poster from "../media/events/Arisenightvigil2017_poster.jpg";
import freshoilnightvigil2017_poster from "../media/events/freshoilnightvigil2017_poster.jpg";
import watchmenevent2017_poster from "../media/events/watchmenevent2017_poster.jpg";
import jesusStillthesame2017_poster from "../media/events/JesusStillthesame2017_poster.jpg";
import loveyouevent2016_poster from "../media/events/loveyouevent2016_poster.jpg";
import revelealingjesuschrist2016_poster from "../media/events/revelealingjesuschrist2016_poster.png";

const EventTimeline = () => {
  const purpleColor = useColorModeValue('purple.500', 'purple.300');
  const orangeColor = useColorModeValue('orange.500', 'orange.300');
  const dividerColor = useColorModeValue('gray.300', 'gray.600');
  const cardBg = useColorModeValue('white', 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  //const headingColor = useColorModeValue('white', 'gray.200');

  const allEvents = [
    // Upcoming events first
    {
      id: 1,
      title: "Alpha Youth Conference 2025",
      type: "conference",
      theme: "Empowing Generations",
      description: "Our annual conference promises to be an impactful time of worship, teaching, and fellowship.",
      date: "Saturday, 15th November 2025",
      time: "4:00 PM - 9:00 PM",
      location: "TBC",
      image: conferencePoster,
      color: purpleColor,
      isUpcoming: true
    },
    // Past events in reverse chronological order
    {
      id: 3,
      title: "Empowering Generations",
      type: "special",
      theme: "The Place of Prayer",
      description: "A powerful session focusing on the importance of prayer in our daily lives.",
      date: "Saturday, 25th November 2023",
      time: "3:00 PM - 5:00 PM",
      location: "Rehoboth Temple, Romford",
      image: empoweringgenerations2023_poster,
      color: purpleColor
    },
    {
      id: 4,
      title: "All Night Fire Up",
      type: "vigil",
      description: "An all-night worship and prayer event to ignite spiritual fire.",
      date: "Friday, 21st June 2019",
      time: "11:30 PM - 5:00 AM",
      location: "Alpha Youth UK Centre, Barking",
      image: allnightstireup_poster,
      color: orangeColor
    },
    {
      id: 5,
      title: "A Height of Empowerment",
      type: "special",
      description: "Special worship, prayer and teaching event with Eddy Arning.",
      date: "Saturday, 24th March 2018",
      time: "5:00 PM - 8:30 PM",
      location: "Alpha Youth UK Centre, Barking",
      image: ahightofempowerment2018,
      color: purpleColor
    },
    {
      id: 6,
      title: "Be Empowered",
      type: "special",
      description: "Fellowship and empowerment session with Minister Ella.",
      date: "2018",
      location: "Alpha Youth UK Centre",
      image: beEmpowered2018_poster,
      color: orangeColor
    },
    {
      id: 7,
      title: "Arise Night Vigil",
      type: "vigil",
      theme: "Arise, shine, for your light has come",
      description: "Night vigil with Bishop Charles Nyane.",
      date: "Friday, 12th May 2017",
      time: "11:30 PM - 5:00 AM",
      location: "Alpha Youth Centre, Barking",
      image: arisenightvigil2017_poster,
      color: purpleColor
    },
    {
      id: 8,
      title: "Fresh Oil Night Vigil",
      type: "vigil",
      description: "Night vigil focused on renewal and fresh anointing (Psalm 92:10).",
      date: "Friday, 10th November 2017",
      time: "11:30 PM - 5:00 AM",
      location: "Alpha Youth Centre, Barking",
      image: freshoilnightvigil2017_poster,
      color: orangeColor
    },
    {
      id: 9,
      title: "Watchmen of the City",
      type: "conference",
      theme: "Isaiah 62:6",
      description: "Youth conference featuring multiple speakers and worship ministers.",
      date: "Saturday, 30th September 2017",
      time: "5:00 PM - 8:30 PM",
      location: "Alpha Youth UK Center, Barking",
      image: watchmenevent2017_poster,
      color: purpleColor
    },
    {
      id: 10,
      title: "Jesus: Still the Same",
      type: "special",
      description: "Worship and teaching event with Eddie Anning and Alpha Youth Choir.",
      date: "Saturday, 1st July 2017",
      time: "5:00 PM - 8:30 PM",
      location: "Alpha Youth Centre, Barking",
      image: jesusStillthesame2017_poster,
      color: orangeColor
    },
    {
      id: 11,
      title: "Love You Event",
      type: "special",
      description: "Special event focused on love and relationships.",
      date: "Thursday, 20th & 27th October 2016",
      time: "7:30 PM - 9:00 PM",
      location: "34-36 East Street, Barking",
      image: loveyouevent2016_poster,
      color: purpleColor
    },
    {
      id: 12,
      title: "Revealing Jesus Christ",
      type: "special",
      description: "Event focused on revealing Christ in our lives.",
      date: "Saturday, 17th December 2016",
      time: "5:00 PM - 8:00 PM",
      location: "34-36 East Street, Barking",
      image: revelealingjesuschrist2016_poster,
      color: orangeColor
    }
  ];

  return (
    <VStack spacing={10} p={{ base: 4, md: 8 }} maxW="1200px" mx="auto">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Text 
          fontSize={{ base: "3xl", md: "4xl" }} 
          fontWeight="bold" 
          textAlign="center"
          bgGradient="linear(to-r, purple.400, orange.400)"
          bgClip="text"
          mt={20}
        >
          Event Timeline
        </Text>
      </motion.div>

      <Box position="relative" w="full">
        {/* Timeline line */}
        <Divider 
          orientation="vertical" 
          height="100%" 
          position="absolute" 
          left="50%" 
          transform="translateX(-50%)"
          borderColor={dividerColor}
          borderWidth="2px"
        />

        <VStack spacing={8} align="stretch" w="full">
          {allEvents.map((event, index) => {
            const isLeft = index % 2 === 0;
            
            return (
              <motion.div
                key={event.id}
                initial={{ opacity: 0, x: isLeft ? -20 : 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Flex
                  justify={isLeft ? "flex-start" : "flex-end"}
                  position="relative"
                  w="full"
                >
                  {/* Timeline dot */}
                  <Box
                    w="40px"
                    h="40px"
                    borderRadius="full"
                    bg={event.color}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    color="white"
                    position="absolute"
                    left="50%"
                    transform="translateX(-50%)"
                    top="-4"
                    zIndex={1}
                  >
                    {event.isUpcoming ? (
                      <Text fontSize="sm" fontWeight="bold">NEW</Text>
                    ) : (
                      <Icon as={FaCalendarAlt} boxSize={4} />
                    )}
                  </Box>

                  {/* Event card */}
                  <Box 
                    bg={cardBg}
                    p={6}
                    borderRadius="lg"
                    boxShadow="lg"
                    w={{ base: "100%", md: "45%" }}
                    ml={isLeft ? 0 : { base: 0, md: "5%" }}
                    mr={isLeft ? { base: 0, md: "5%" } : 0}
                    borderLeft={isLeft ? "4px solid" : "none"}
                    borderRight={!isLeft ? "4px solid" : "none"}
                    borderColor={event.color}
                  >
                    <Text fontSize="xl" fontWeight="bold" mb={2} color={event.color}>
                      {event.title}
                    </Text>
                    {event.theme && (
                      <Text fontStyle="italic" color={textColor} mb={2}>
                        "{event.theme}"
                      </Text>
                    )}
                    <Text color={textColor} mb={4}>
                      {event.description}
                    </Text>
                    
                    <VStack align="start" spacing={2}>
                      <Flex align="center">
                        <Icon as={FaCalendarAlt} color={event.color} mr={2} />
                        <Text>{event.date}</Text>
                      </Flex>
                      {event.time && (
                        <Flex align="center">
                          <Icon as={FaClock} color={event.color} mr={2} />
                          <Text>{event.time}</Text>
                        </Flex>
                      )}
                      <Flex align="center">
                        <Icon as={FaMapMarkerAlt} color={event.color} mr={2} />
                        <Text>{event.location}</Text>
                      </Flex>
                      {event.speakers && (
                        <Flex align="center">
                          <Icon as={FaUsers} color={event.color} mr={2} />
                          <Text>Speakers: {event.speakers}</Text>
                        </Flex>
                      )}
                    </VStack>
                    
                    {event.image && (
                      <Image
                        src={event.image}
                        alt={event.title}
                        mt={4}
                        borderRadius="md"
                        boxShadow="sm"
                        maxH="200px"
                        objectFit="contain"
                      />
                    )}
                  </Box>
                </Flex>
              </motion.div>
            );
          })}
        </VStack>
      </Box>
    </VStack>
  );
};

export default EventTimeline;